// This file is used for development builds
export const environment = {
  production: false,
  name: 'development',
  apiUrl: 'https://psldqp-platform-gsbserhkbfe5bcbb.westeurope-01.azurewebsites.net/api'
  // Uncomment below to use dev tunnel:
  // apiUrl: 'https://fh6t2zhn-7206.uks1.devtunnels.ms/api'
};
